export class MyCertificationFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getMyCertifications(filter) {
    return this.instance.get('/v1/my-certification', {
      params: filter || null,
    });
  }

  getMyCertification(id) {
    return this.instance.get(`/v1/my-certification/${id}`);
  }

  linkMyCertification(data) {
    return this.instance.post('/v1/my-certification', data);
  }

  createCertificationStandardResponse(
    myCertificationId,
    certificationStandardId,
    data,
  ) {
    return this.instance.post(
      `/v1/my-certification/${myCertificationId}/certifications-standard/${certificationStandardId}/response`,
      data,
    );
  }

  getCertificationStandardResponse(myCertificationId, certificationStandardId) {
    return this.instance.get(
      `/v1/my-certification/${myCertificationId}/certifications-standard/${certificationStandardId}/response`,
      // {
      //   params: filter || null,
      // },
    );
  }

  createCertificationStandardFiles(
    myCertificationId,
    certificationStandardId,
    data,
  ) {
    const formData = new FormData();
    formData.append('file', data?.file);
    formData.append('description', data?.description);
    formData.append('dueDate', data?.dueDate);

    if (data?.tags?.length > 0) formData.append('tags', data?.tags);

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return this.instance.post(
      `/v1/my-certification/${myCertificationId}/certifications-standard/${certificationStandardId}/files`,
      formData,
      config,
    );
  }

  listCertificationStandardFiles(myCertificationId, certificationStandardId) {
    return this.instance.get(
      `/v1/my-certification/${myCertificationId}/certifications-standard/${certificationStandardId}/files`,
      {
        // params: filter || null,
      },
    );
  }

  getCertificationStandardResponseTotals(myCertificationId) {
    return this.instance.get(
      `/v1/my-certification/${myCertificationId}/certifications-standard-totals`,
      {
        // params: filter || null,
      },
    );
  }
}

export default MyCertificationFactory;
